import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { useColors, ThemeColors } from '../../hooks/useColors';

interface CheckboxProps {
  checked: boolean;
  onPress: () => void;
  disabled?: boolean;
  size?: number;
}

export function Checkbox({ checked, onPress, disabled = false, size = 20 }: CheckboxProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  
  return (
    <TouchableOpacity
      style={[
        styles.checkbox,
        { width: size, height: size },
        checked && styles.checked,
        disabled && styles.disabled,
      ]}
      onPress={disabled ? undefined : onPress}
      activeOpacity={disabled ? 1 : 0.7}
    >
      {checked && (
        <Feather
          name="check"
          size={size * 0.7}
          color={disabled ? colors.textLight : colors.surface}
        />
      )}
    </TouchableOpacity>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  checkbox: {
    borderWidth: 2,
    borderColor: colors.primary,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.backgroundSecondary,
  },
  checked: {
    backgroundColor: colors.primary,
  },
  disabled: {
    borderColor: colors.textLight,
    backgroundColor: colors.background,
    opacity: 0.6,
  },
});